import * as React from "react";
import { Suspense } from "react";
import Helmet from "react-helmet";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import ChatLoader from "./Chat/ChatLoader";
import { CountryProvider } from "./Contexts/CountryContext";
import { FeedbackProvider } from "./Contexts/FeedbackContext";
import { HostProvider } from "./Contexts/HostContext";
import { WebpushProvider } from "./Contexts/WebpushContext";
import MobileFooter from "./Footer/MobileFooter";
import { PageFooter } from "./Footer/PageFooter";
import { HeaderSelector } from "./Header/HeaderSelector";
import ScrollToTop from "./Helper/ScrollToTop";
import HostLoader from "./Host/HostLoader";
import InstructionBox from "./InstructionBox/InstructionBox";
import CountryReducer from "./Reducers/CountryReducer";
import FeedbackReducer from "./Reducers/FeedbackReducer";
import HostReducer from "./Reducers/HostReducer";
import { HeaderElements } from "./HeaderElements/HeaderElements";
import StickyHeader from "./StickyHeader";
import TopMenu from "./TopMenu";
import { IntlProvider } from "react-intl";
import Grid from "./Grid";
import { CookieConsent } from "./CookieConsent/CookieConsent";
import KitHomeHeader from "./WebmasterKit/KitHomeHeader";
var Survey = /*#__PURE__*/React.lazy(function () {
  return import("./Survey/Survey");
});
var Profile = /*#__PURE__*/React.lazy(function () {
  return import("./ProfilePage/Profile");
});
var Agb = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/AGB/agb");
});
var Datenschutz = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/Datenschutz/Datenschutz");
});
var Datenschutz201901 = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/Datenschutz/Datenschutz201901");
});
var Datenschutz201805 = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/Datenschutz/Datenschutz201805");
});
var Impressum = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/Impressum/Impressum");
});
var Category = /*#__PURE__*/React.lazy(function () {
  return import("./Category/Category");
});
var PhonesexPage = /*#__PURE__*/React.lazy(function () {
  return import("./Phonesex/PhonesexPage");
});
var FeedbackDisplay = /*#__PURE__*/React.lazy(function () {
  return import("./Feedback/FeedbackDisplay");
});
var Livecam = /*#__PURE__*/React.lazy(function () {
  return import("./Livecam/Livecam");
});
var Kaufvideos = /*#__PURE__*/React.lazy(function () {
  return import("./Kaufvideos/Kaufvideos");
});
if (!Intl.PluralRules) {
  require("@formatjs/intl-pluralrules/polyfill");
  require("@formatjs/intl-pluralrules/locale-data/de"); // Add locale data for de
}
// @ts-ignore
if (!Intl.RelativeTimeFormat) {
  require("@formatjs/intl-relativetimeformat/polyfill");
  require("@formatjs/intl-relativetimeformat/locale-data/de"); // Add locale data for de
}
function App() {
  var home = window.layoutSettings.seo.home;
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: "de",
    messages: window.languageData
  }, /*#__PURE__*/React.createElement(CountryProvider, {
    reducer: CountryReducer
  }, /*#__PURE__*/React.createElement(HostProvider, {
    reducer: HostReducer
  }, /*#__PURE__*/React.createElement(FeedbackProvider, {
    reducer: FeedbackReducer
  }, /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, home.meta.title), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: home.meta.description
  })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(HeaderSelector, null), /*#__PURE__*/React.createElement(TopMenu, null), /*#__PURE__*/React.createElement(KitHomeHeader, null), /*#__PURE__*/React.createElement(InstructionBox, null), /*#__PURE__*/React.createElement(WebpushProvider, null, /*#__PURE__*/React.createElement(HostLoader, null), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/:page(|welcome)",
    exact: true,
    strict: true,
    render: function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderElements, {
        canIndex: window.index.home,
        title: home.meta.title,
        description: home.meta.description
      }), /*#__PURE__*/React.createElement(Grid, {
        page: 1
      }));
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/seite/:page(\\d+)/",
    render: function (_a) {
      var match = _a.match;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderElements, {
        canIndex: false,
        title: home.meta.title,
        description: home.meta.description
      }), /*#__PURE__*/React.createElement(Grid, {
        page: parseInt(match.params.page, 10)
      }));
    }
  }), /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      style: {
        height: "750px"
      }
    }, "\u00A0")
  }, /*#__PURE__*/React.createElement(Route, {
    path: "/page/agb",
    strict: true,
    component: Agb
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/imprint",
    strict: true,
    component: Impressum
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz",
    strict: true,
    component: Datenschutz
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz201901",
    strict: true,
    component: Datenschutz201901
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz201805",
    strict: true,
    component: Datenschutz201805
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/profil/:name(.+)/",
    strict: true,
    component: Profile
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/kategorie/:category(anal|fetisch|milf)/",
    strict: true,
    component: Category
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/telefonsex/",
    strict: true,
    component: PhonesexPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/chatcam/",
    strict: true,
    component: Livecam
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/kaufvideos/",
    strict: true,
    component: Kaufvideos
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/telefonsex",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/telefonsex/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/chatcam",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/chatcam/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/kaufvideos",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/kaufvideos/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Telefonsex"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/telefonsex/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Telefonsex/"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/telefonsex/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Chat-Cam",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/chatcam/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Chat-Cam/",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/chatcam/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Kaufvideos",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/kaufvideos/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Kaufvideos/",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/kaufvideos/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/page/agb",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/page/agb/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/page/imprint",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/page/imprint/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/page/datenschutz/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz201901",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/page/datenschutz201901/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz201805",
    strict: true
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/page/datenschutz201805/"
  }))), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    render: function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "page"
      }, /*#__PURE__*/React.createElement(HeaderElements, {
        canIndex: false,
        title: home.meta.title,
        description: home.meta.description
      }), /*#__PURE__*/React.createElement("h1", null, "Page not found"));
    }
  })), /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Survey, null))), /*#__PURE__*/React.createElement(StickyHeader, null), /*#__PURE__*/React.createElement(MobileFooter, null), /*#__PURE__*/React.createElement(PageFooter, null)), /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(FeedbackDisplay, null)), /*#__PURE__*/React.createElement(ChatLoader, null), /*#__PURE__*/React.createElement(CookieConsent, null)))));
}
export default App;